// extracted by mini-css-extract-plugin
module.exports = {"inline-modal":"style_inline-modal__2gwZS"};